import { OCR_STATUS } from "@/constants/caseFileOcrStatus";

import { type OcrTextBodyViewProps } from "./types";

export function OcrTextBodyView({
  status,
  sections,
  containerRef,
  setSectionRef,
}: OcrTextBodyViewProps) {
  if (status.kind === OCR_STATUS.IDLE) {
    return null;
  } else if (status.kind === OCR_STATUS.LOADING) {
    return (
      <div className="flex h-full items-center justify-center p-4 text-sm text-muted-foreground">
        Loading OCR…
      </div>
    );
  } else if (status.kind === OCR_STATUS.NOT_FOUND) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 p-4 text-center">
        <span className="text-2xl">🔍</span>
        <p className="text-sm font-medium text-muted-foreground">OCR not available</p>
        <p className="text-xs text-text-disabled">
          No OCR text has been generated for this file yet.
        </p>
      </div>
    );
  } else if (status.kind === OCR_STATUS.ERROR) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 p-4 text-center">
        <span className="text-2xl">⚠️</span>
        <p className="text-sm font-medium text-destructive-text">{status.message}</p>
      </div>
    );
  }

  if (sections.length === 0) {
    return (
      <pre className="h-full overflow-auto whitespace-pre-wrap break-words p-4 font-mono text-xs text-foreground">
        {status.text}
      </pre>
    );
  }

  return (
    <div ref={containerRef} className="h-full overflow-auto p-4">
      {sections.map((section) => (
        <div
          key={section.pageNumber}
          ref={(el) => setSectionRef(section.pageNumber, el)}
          data-page={section.pageNumber}
        >
          <div className="mb-1 border-b border-border-strong pb-1 font-sans text-xs font-semibold text-muted-foreground">
            Page {section.pageNumber}
          </div>
          <pre className="mb-4 whitespace-pre-wrap break-words font-mono text-xs text-foreground">
            {section.content}
          </pre>
        </div>
      ))}
    </div>
  );
}
